import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams, IRowNode } from '@ag-grid-community/core';
import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { IconComponent } from '@shared/components/icon/icon.component';
import { MessagesConstants } from '@shared/constants/messages.constants';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

type ChangeOrderParams = ICellRendererParams & {
  deleteClickFN: ((params: { rowNode: IRowNode }) => void) | undefined;
  downloadClickFN: ((params: { rowNode: IRowNode }) => void) | undefined;
  downloadPermission$: BehaviorSubject<boolean>;
  isAdmin: boolean;
  isChangeOrdersWorkflowLocked: Signal<boolean>;
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective, IconComponent, NgClass, AsyncPipe],
  selector: 'aux-change-order-actions',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  template: `
    <div class="flex items-center justify-center space-x-2">
      @if ((params.downloadPermission$ | async) || params.isAdmin) {
        <button
          class="btn h-8 w-8 rounded-full p-0 text-aux-blue"
          type="button"
          auxTooltip="Download"
          (click)="onDownloadClick()"
        >
          <aux-icon name="Download" />
        </button>
      }

      <button
        class="btn h-8 w-8 rounded-full p-0"
        [ngClass]="{
          'opacity-50': params.isChangeOrdersWorkflowLocked(),
        }"
        type="button"
        [disabled]="params.isChangeOrdersWorkflowLocked()"
        [auxTooltip]="
          params.isChangeOrdersWorkflowLocked()
            ? MessagesConstants.LOCKED_FOR_PERIOD_CLOSE
            : 'Delete'
        "
        (click)="onDeleteClick()"
      >
        <aux-icon name="Trash" class="text-aux-error" />
      </button>
    </div>
  `,
})
export class ChangeOrderActionsComponent implements ICellRendererAngularComp {
  protected readonly MessagesConstants = MessagesConstants;
  params!: ChangeOrderParams;

  agInit(params: ChangeOrderParams): void {
    this.params = params;
  }

  onDeleteClick() {
    if (this.params.deleteClickFN) {
      this.params.deleteClickFN({ rowNode: this.params.node });
    }
  }

  onDownloadClick() {
    if (this.params.downloadClickFN) {
      this.params.downloadClickFN({ rowNode: this.params.node });
    }
  }

  refresh(): boolean {
    return false;
  }
}
